const getDateFromYYYYMMDDString = dateInYYYYMMDD => {
  const newDate = new Date(
    dateInYYYYMMDD.substring(0, 4),
    dateInYYYYMMDD.substring(4, 6) - 1,
    dateInYYYYMMDD.substring(6, 8)
  );
  return newDate;
};

export default getDateFromYYYYMMDDString;
